import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { hasFeature } from '@/features/feature-flags';
import { FEATURES } from '@/features/feature-flags/feature-flags.constants';
import { WorldModelDocScreen } from '@/features/world-model/world-model-screen';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/world-model/')({
  beforeLoad() {
    if (hasFeature(FEATURES.WORLD_MODEL)) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: WorldModelDocScreen,
  validateSearch: z.object({
    id: z.string().optional().catch(undefined),
  }).parse,
});
